import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, CircularProgress, Typography, Alert, Button } from "@mui/material";
import axios from "../api";
import { postLoginPath } from "../utils/postLoginPath";

function SsoCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setError("Missing SSO token.");
      return;
    }
    (async () => {
      try {
        localStorage.setItem("adminToken", token);
        const res = await axios.get("/auth/me", { skipAuthRedirect: true });
        const user = res.data.result;
        localStorage.setItem("adminUser", JSON.stringify(user));
        localStorage.setItem("isAdminLoggedIn", "true");
        navigate(postLoginPath(user?.role), { replace: true });
      } catch (e) {
        localStorage.removeItem("adminToken");
        localStorage.removeItem("adminUser");
        localStorage.removeItem("isAdminLoggedIn");
        setError(e.response?.data?.message || "SSO login failed.");
      }
    })();
  }, [params, navigate]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: 2,
        p: 3,
      }}
    >
      {error ? (
        <>
          <Alert severity="error" sx={{ maxWidth: 420 }}>
            {error}
          </Alert>
          <Button variant="contained" onClick={() => navigate("/login", { replace: true })}>
            Back to sign in
          </Button>
        </>
      ) : (
        <>
          <CircularProgress />
          <Typography>Completing sign-in…</Typography>
        </>
      )}
    </Box>
  );
}

export default SsoCallback;
